<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
   data-testid="assets-icon-sk-close-chip-svg">
    <circle
      cx="10"
      cy="10"
      r="10"
      fill="#EDEFF3"
    data-testid="assets-icon-sk-close-chip-circle" />
    <rect
      x="5.75781"
      y="4.34326"
      width="14"
      height="2"
      rx="1"
      transform="rotate(45 5.75781 4.34326)"
      fill="#595959"
    data-testid="assets-icon-sk-close-chip-rect" />
    <rect
      x="15.6582"
      y="5.75732"
      width="14"
      height="2"
      rx="1"
      transform="rotate(135 15.6582 5.75732)"
      fill="#595959"
    data-testid="assets-icon-sk-close-chip-rect-2" />
  </svg>
</template>